import React from 'react';
import * as lib from '~/dependencies';
import Row from './Row';
import { Container } from './styles';

const List = ({ numRows, ...rest }) => (
  <Container>
    {Array.from({ length: numRows }, (_, rowId) => (
      <Row key={rowId} {...rest} />
    ))}
  </Container>
);

export default List;

List.defaultProps = {
  numRows: 6,
};

List.propTypes = {
  numRows: lib.PropTypes.number,
};
